import { canadaTestimonialData } from "../../data/canadaTaxData";
import { Star } from "lucide-react";

export const CanadaTestimonialsSection = () => (
  <section className="py-24 px-6 bg-[#F3F5F8]">
    <div className="max-w-[87.5rem] mx-auto">
      <div className="text-center mb-14">
        <span className="text-[#C8283A] text-xs font-black uppercase tracking-[0.2em] mb-3 block" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaTestimonialData.sectionLabel}
        </span>
        <h2 className="text-[#0B1829] font-black leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3rem)", letterSpacing: "-0.03em" }}>
          {canadaTestimonialData.headline1}
          <br />
          <span className="text-[#C8283A] italic">{canadaTestimonialData.headline2}</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {canadaTestimonialData.items.map((t, i) => (
          <div
            key={i}
            className="bg-white rounded-xl border border-[#E8ECF0] p-6 flex flex-col hover:shadow-md hover:border-[#D4A843]/30 transition-all duration-300"
          >
            {/* Stars */}
            <div className="flex gap-0.5 mb-4">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={13} className="text-[#D4A843] fill-[#D4A843]" />
              ))}
            </div>
            <p className="text-[#5A6A7A] text-sm leading-relaxed italic flex-1 mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              "{t.text}"
            </p>
            <div>
              <p className="text-[#0B1829] font-bold text-sm" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{t.name}</p>
              <p className="text-[#8BA3BE] text-xs mt-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{t.meta}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
